import { apiUrls } from "../../../actprep-ui/utils/urls";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import ContentBox from "../../../actprep-ui/components/ContentBox";
import PaginatedTable from "../../../actprep-ui/components/PaginatedTable";
import layout from "../../../actprep-ui/constants/layout";
import StudentTableDialog from "../../../components/StudentTableDialog";
import { useState } from "react";
import useDisclosure from "../../../actprep-ui/hooks/ui/useDisclosure";
import Typography from "@mui/material/Typography";
import { sortingModes } from "../../../actprep-ui/constants/dataGrid";

export default function Organizations() {
  const [dialogTitle, setDialogTitle] = useState("");
  const disclosure = useDisclosure();
  const { onOpen } = disclosure;
  const [selectedOrganizationUUID, setSelectedOrganizationUUID] =
    useState(null);

  const handleRowClick = (params) => {
    setSelectedOrganizationUUID(params.row.uuid);
    setDialogTitle(`Students in '${params.row.name}' Organization`);
    onOpen();
  };

  const organizationsColumns = [
    {
      field: "name",
      headerName: "Organization Name",
      width: 200,
      valueGetter: (value, row) => row.name || "",
    },
    {
      field: "student_count",
      headerName: "Number of Students",
      type: "number",
      width: 150,
    },
  ];

  return (
    <>
      <Grid
        sx={{
          marginTop: `${layout.navBarHeight + 1}rem`,
        }}
        size={12}
      >
        <ContentBox style={{ maxHeight: "85vh", height: "500rem" }}>
          <Typography variant="h5" fontWeight="bold">
            Organizations
          </Typography>
          <Box sx={{ height: "90%" }}>
            <PaginatedTable
              searchable
              tableName={"Organizations"}
              apiUrl={apiUrls.admin.organizations()}
              columns={organizationsColumns}
              urlParams={{
                keep_related: "true",
                values: ["name", "student_count", "uuid"],
              }}
              disableCellFocus
              onRowClick={handleRowClick}
              sortingMode={sortingModes.SERVER}
            />
          </Box>
        </ContentBox>
      </Grid>
      <StudentTableDialog
        title={dialogTitle}
        filterParams={{
          search_params: {
            organization_id: selectedOrganizationUUID,
          },
        }}
        {...disclosure}
      />
    </>
  );
}
